import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  UserChat: [],
  Pagination: null,
  isSuccess: false,
  message: null,
  status: "idle",
  error: null,
};

// Accepts { pageNumber, pageSize } — defaults to page 1, size 10
export const fetchUserChat = createAsyncThunk(
  `/AiAgent/GetAIAgentChats`,
  async ({ pageNumber = 1, pageSize = 10 } = {}) => {
    const response = await axiosInstanceAuth.get(
      `/AiAgent/GetAIAgentChats?Module=CRM&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return { data: response?.data, pageNumber };
  }
);

const ChatSlice = createSlice({
  name: "UserChat",
  initialState,
  reducers: {
    ChatAdded: {
      reducer(state, action) {
        state.UserChat?.push(action.payload);
      },
    },
    resetChat(state) {
      state.UserChat = [];
      state.Pagination = null;
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchUserChat?.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUserChat?.fulfilled, (state, action) => {
        state.status = "succeeded";
        const { data, pageNumber } = action.payload;
        state.message = data?.Message;
        state.isSuccess = data?.IsSuccess;

        // Page 1 → replace all; subsequent pages → prepend older messages
        if (pageNumber === 1) {
          state.UserChat = data?.Data ?? [];
        } else {
          state.UserChat = [...(data?.Data ?? []), ...state.UserChat];
        }

        // Store full pagination metadata (excluding Data to keep it lean)
        const { ...meta } = data ?? {};
        state.Pagination = meta;
      })
      .addCase(fetchUserChat?.rejected, (state, action) => {
        state.error = action?.error?.message;
        state.status = "failed";
      });
  },
});

export const getUserChat = state => state.UserChat;

export const { ChatAdded, resetChat } = ChatSlice.actions;

export default ChatSlice.reducer;
